import "../../../design/about.css";
import aboutImage from "../../../assets/about/aboutImage.avif";
import { FaUserGraduate, FaHandHoldingHeart, FaMagic, FaRocket } from "react-icons/fa";

export default function About() {

    const cards = [
        {
            title: "მასწავლებელს",
            icon: <FaUserGraduate />,
            colorClass: "card-blue",
            text: "ახალბედა მასწავლებლებს ხშირად სჭირდებათ საკუთარი თავის რეკლამა. ჩვენი პლატფორმა ეხმარება მათ, რომ მარტივად მიაწვდინონ ხმა მშობლებს."
        },
        {
            title: "მშობელს",
            icon: <FaHandHoldingHeart />,
            colorClass: "card-green",
            text: "მშობლებს ვაძლევთ სწრაფ გზას იპოვონ სასურველი მასწავლებელი საგნის, ფასისა და მდებარეობის მიხედვით."
        },
        {
            title: "მარტივი პროცესი",
            icon: <FaMagic />,
            colorClass: "card-purple",
            text: (
                <div className="processWrapper">
                    <div className="processStep">
                        <span className="stepEmoji">📍</span>
                        <p>მასწავლებელი რეგისტრაციას გადის, რათა რუკაზე გამოჩნდეს. <em>"ეჰეი! მე ვასწავლი ბავშვებს. ❤️"</em></p>
                    </div>

                    <div className="processStep">
                        <span className="stepEmoji">🔎</span>
                        <p>მშობელი სასურველი საგნის მენტორს ეძებს რუკაზე.</p>
                    </div>

                    <div className="processStep">
                        <span className="stepEmoji">📞</span>
                        <p>სასურველი რეპეტიტორის მოძიების შემდეგ მშობელი ურეკავს მასწავლებელს.</p>
                    </div>

                    <div className="processStep finalStep">
                        <FaRocket className="rocketIcon" />
                        <p>ჰიუსტონ — არის კავშირი! ვუჰუუუუ 🎉 <br/> <strong>სწავლა იწყება! 💪🧠</strong></p>
                    </div>
                </div>
            )
        }
    ];

    return (
        <section id="aboutUs" className="aboutSection">
            {/* ფონური დეკორაციები */}
            <div className="about-blob about-blob-1"></div>
            <div className="about-blob about-blob-2"></div>

            <div className="aboutHeader">
                <div className="headerBadge">როგორ მუშაობს</div>
                <h2>აღმოაჩინე ცოდნის სამყარო 🌟</h2>
                <p>
                    მარტივი პლატფორმა, რომელიც აკავშირებს მშობლებს
                    და საუკეთესო მასწავლებლებს ერთ სივრცეში.
                </p>
            </div>

            <div className="aboutContainer">
                <div className="aboutImageWrapper">
                    <div className="imageDecoration"></div>
                    <img src={aboutImage} alt="teacher platform"/>
                </div>

                <div className="aboutCards">
                    {cards.map((card, index) => (
                        <div key={index} className={`aboutCard ${card.colorClass}`}>
                            <div className="cardHeader">
                                <span className="cardIcon">{card.icon}</span>
                                <h3>{card.title}</h3>
                            </div>
                            <div className="aboutCardText">{card.text}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}